export enum PrepTicketPromptMode {
  OFF = "OFF",
  CONFIRM = "CONFIRM",
  SELECT = "SELECT",
}
